import { DEFAULT_TIMEZONE } from '~/utils/constants'

export default (ctx, inject) => {
  const { $dayjs } = ctx

  try {
    if ($dayjs && $dayjs.tz && typeof $dayjs.tz.setDefault === 'function') {
      $dayjs.tz.setDefault(DEFAULT_TIMEZONE)
    }
  } catch (e) {}

  const dayjsWithDefaultTz = (...args) => {
    // Create a Day.js instance from provided args
    const instance = args.length > 0 ? $dayjs(...args) : $dayjs()
    // If timezone plugin is available, convert to default TZ
    if (instance && typeof instance.tz === 'function') {
      return instance.tz(DEFAULT_TIMEZONE)
    }
    return instance
  }

  // Preserve static methods/properties (e.g., extend, utc, tz, isDayjs)
  Object.keys($dayjs || {}).forEach(key => {
    dayjsWithDefaultTz[key] = $dayjs[key]
  })

  inject('dayjs', dayjsWithDefaultTz)
}
